import React, { useState } from "react";
import icon from "../../../assets/images/brand/logo_2_107x70.png";
// import style from "../login/login.module.css";
import style from "../levelOneLogin/levelOneLogin.module.css"
import Input from "../../../components/Input";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { _axios } from "../../../utils/axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { BASE_URL } from "../../../constants/Constants";

const levelOneLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  let navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onLogin = () => {
    console.log('test', email, password)
    if(email.length === 0 || password.length === 0){
      ErrorToast("Please enter valid email/number or password")
      return
    }
    if (!isNaN(Number(email)) && email.length < 10) {
      ErrorToast("Please enter valid mobile number")
      return
    }
     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

     const isValid = emailRegex.test(email);
    if(isNaN(Number(email)) && !isValid){
      ErrorToast("Please enter valid email")
      return
    }
    _axios.post(`${BASE_URL}/api/users/login`,
      !isNaN(Number(email)) ? {
        "mobile": email,
        "password": password
      } :
        {
          "email": email,
          "password": password
        })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        localStorage.setItem('userDetails', JSON.stringify(response?.data?.data))
        if (response?.data?.data?.role === 'super-admin') {
          SuccessToast('Login Successfully')
          navigate('/dashboard');
        }
        else {
          SuccessToast('Login Successfully')
          navigate('/onboarding/verification-page');
        }
        // handle success
        console.log(response);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });


  }

  return (
    <div className={style.loginContainer}>
    <div className={style.loginForm}>
      <div className={style.logo}>
        <img src={icon} alt="Logo" />
      </div>
      <div className={style.loginText}>Administrator Login</div>

      <br />

      <Input
        title={"Email or Mobile"}
        placeholder={"Email or Mobile"}
        isIcon={true}
        icon={"fa fa-user-o"}
        type="tel"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />


      <Input
        title={"Password"}
        placeholder={"Password"}
        isIcon={true}
        icon={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
        type={showPassword ? "text" : "password"}
        onClick={togglePasswordVisibility}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />



      {/* <div className={style.forgotPassword}>
        {" "}
        <Link to="/onboarding/forgot-password">Forgot Password?</Link>
      </div> */}

      <button className={style.loginButton} onClick={onLogin} >Login</button>

      {/* <div className={style.createAccount}>
        Don't have an account yet?{" "}
        <Link to="/onboarding/create-account">Create an account</Link>
      </div> */}
    </div>
  </div>

  )
}

export default levelOneLogin
